(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
if (!customElements.get('ub-cart-price-cleanup')) {
  customElements.define('ub-cart-price-cleanup', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('[id^="shopify-section-"]');
      if (!this.section) return;
      this.observer = new MutationObserver(() => this.cleanPrices());
      this.resizeObserver = new ResizeObserver(() => this.queueSummaryFit());
      this.fontRefresh = () => this.queueSummaryFit();
      document.fonts?.addEventListener('loadingdone', this.fontRefresh);
      this.refresh = () => this.observeAndClean();
      document.addEventListener('shopify:section:load', this.refresh);
      document.addEventListener('DOMContentLoaded', this.refresh, { once: true });
      this.observeAndClean();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.fitFrame);
      document.fonts?.removeEventListener('loadingdone', this.fontRefresh);
      document.removeEventListener('shopify:section:load', this.refresh);
      document.removeEventListener('DOMContentLoaded', this.refresh);
    }

    observeAndClean() {
      this.observer.disconnect();
      this.observer.observe(this.section, { childList: true, characterData: true, subtree: true });
      const footer = document.getElementById('main-cart-footer');
      if (footer) {
        this.observer.observe(footer.closest('[id^="shopify-section-"]') || footer, {
          childList: true, characterData: true, subtree: true
        });
      }
      this.cleanPrices();
    }

    queueSummaryFit() {
      cancelAnimationFrame(this.fitFrame);
      this.fitFrame = requestAnimationFrame(() => this.fitSummary());
    }

    fitSummary() {
      const row = document.querySelector('#main-cart-footer .totals');
      const label = row?.querySelector('.totals__total');
      const value = row?.querySelector('.totals__total-value');
      if (!row || !label || !value || !row.clientWidth) return;
      const targets = [row, label, value];
      if (!this.resizeTargets || targets.some((node, index) => node !== this.resizeTargets[index])) {
        this.resizeObserver.disconnect();
        targets.forEach((node) => this.resizeObserver.observe(node));
        this.resizeTargets = targets;
      }
      // Measure at the selected sizes, then shrink only when the row cannot fit.
      row.style.setProperty('--ub-cart-summary-fit', '1');
      const style = getComputedStyle(row);
      const available = row.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
      const gap = parseFloat(style.columnGap) || 0;
      const needed = label.getBoundingClientRect().width + value.getBoundingClientRect().width;
      const fit = Math.min(1, Math.max(0.1, (available - gap - 2) / Math.max(needed, 1)));
      row.style.setProperty('--ub-cart-summary-fit', String(Math.floor(fit * 1000) / 1000));
    }

    cleanPrices() {
      const prices = [
        ...this.section.querySelectorAll('.cart-item__details > div.product-option, .cart-item__details > .cart-item__discounted-prices, .cart-item__price-wrapper, .quantity-popover__info volume-pricing'),
        ...document.querySelectorAll('#main-cart-footer .totals__total-value, #main-cart-footer .totals__subtotal-value')
      ];
      prices.forEach((price) => {
        const nodes = document.createTreeWalker(price, NodeFilter.SHOW_TEXT);
        while (nodes.nextNode()) {
          const node = nodes.currentNode;
          const cleaned = node.nodeValue.replace(/[\t \u00a0\u202f]*\bMYR\b/g, '');
          if (cleaned !== node.nodeValue) node.nodeValue = cleaned;
        }
      });
      document.querySelectorAll('#main-cart-footer .cart__note label[for="Cart-note"]').forEach((label) => {
        if (label.textContent !== 'Order Instructions') label.textContent = 'Order Instructions';
      });
      document.querySelectorAll('#main-cart-footer .tax-note').forEach((note) => {
        const nodes = document.createTreeWalker(note, NodeFilter.SHOW_TEXT);
        while (nodes.nextNode()) {
          const node = nodes.currentNode;
          const cleaned = node.nodeValue.replace(/^\s*Taxes\s+included\.\s*/i, '');
          if (cleaned !== node.nodeValue) node.nodeValue = cleaned;
        }
      });
      this.queueSummaryFit();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
if (!customElements.get('ub-search-results-cleanup')) {
  customElements.define('ub-search-results-cleanup', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('[id^="shopify-section-"]');
      if (!this.section) return;
      this.cleanResults();
      this.observer = new MutationObserver(() => this.cleanResults());
      this.observer.observe(this.section, { childList: true, characterData: true, subtree: true });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    cleanResults() {
      const filters = this.section.querySelector('#main-search-filters');
      filters?.querySelectorAll('price-range, input[name="filter.v.price.gte"], input[name="filter.v.price.lte"]').forEach((control) => {
        const details = control.closest('details');
        if (!details || !filters.contains(details)) return;
        details.querySelectorAll('input').forEach((input) => { input.disabled = true; });
        details.remove();
      });

      // Only price text is changed; product names, links and search terms stay intact.
      this.section.querySelectorAll('.template-search__results .price, .template-search__search .predictive-search .price').forEach((price) => {
        const textNodes = document.createTreeWalker(price, NodeFilter.SHOW_TEXT);
        while (textNodes.nextNode()) {
          const node = textNodes.currentNode;
          const cleaned = node.nodeValue.replace(/[\t \u00a0\u202f]*\bMYR\b/g, '');
          if (cleaned !== node.nodeValue) node.nodeValue = cleaned;
        }
      });

      const labels = [
        ['.mobile-facets__open-label, .mobile-facets__heading, .facet-filters__label label, .mobile-facets__sort label', /\bsort\b/gi, 'Sort']
      ];
      labels.forEach(([selector, pattern, replacement]) => {
        this.section.querySelectorAll(selector).forEach((label) => {
          const textNodes = document.createTreeWalker(label, NodeFilter.SHOW_TEXT);
          while (textNodes.nextNode()) {
            const node = textNodes.currentNode;
            const capitalised = node.nodeValue.replace(pattern, replacement);
            if (capitalised !== node.nodeValue) node.nodeValue = capitalised;
          }
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugly-butter-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);
if (!customElements.get('ub-header-cart-count')) {
  customElements.define('ub-header-cart-count', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('[id^="shopify-section-"]');
      if (!this.section) return;
      this.refresh = () => this.queueAlignment();
      this.mutations = new MutationObserver(this.refresh);
      this.mutations.observe(this.section, {
        childList: true,
        characterData: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'width', 'height', 'viewBox'],
      });
      this.sizes = new ResizeObserver(this.refresh);
      window.addEventListener('resize', this.refresh);
      this.section.addEventListener('pointerover', this.refresh);
      this.section.addEventListener('pointerout', this.refresh);
      document.fonts?.addEventListener('loadingdone', this.refresh);
      document.fonts?.ready.then(() => {
        if (this.isConnected) this.queueAlignment();
      });
      this.queueAlignment();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.mutations?.disconnect();
      this.sizes?.disconnect();
      window.removeEventListener('resize', this.refresh);
      this.section?.removeEventListener('pointerover', this.refresh);
      this.section?.removeEventListener('pointerout', this.refresh);
      document.fonts?.removeEventListener('loadingdone', this.refresh);
    }

    queueAlignment() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.alignCount());
    }

    alignCount() {
      const cart = this.section.querySelector('#cart-icon-bubble');
      const icon = cart?.querySelector('.svg-wrapper svg');
      const badge = cart?.querySelector('.cart-count-bubble');
      const number = badge?.querySelector('span:not(.visually-hidden)');
      if (!icon || !number || !number.textContent.trim()) return;
      const bounds = cart.getBoundingClientRect();
      if (!bounds.width || !bounds.height || !cart.offsetWidth || !cart.offsetHeight) return;
      const targets = [cart, icon, badge];
      if (!this.targets || targets.some((node, index) => node !== this.targets[index])) {
        this.sizes.disconnect();
        targets.forEach(node => this.sizes.observe(node));
        this.targets = targets;
      }
      const matrix = icon.getScreenCTM();
      if (!matrix) return;
      const box = icon.getBBox();
      if (!box.width || !box.height) return;
      const corners = [
        [box.x, box.y], [box.x + box.width, box.y],
        [box.x, box.y + box.height], [box.x + box.width, box.y + box.height],
      ].map(([x, y]) => new DOMPoint(x, y).matrixTransform(matrix));
      const scaleX = bounds.width / cart.offsetWidth;
      const scaleY = bounds.height / cart.offsetHeight;
      let stroke = 0;
      icon.querySelectorAll('path, rect, circle, ellipse, line, polyline, polygon').forEach(shape => {
        const style = getComputedStyle(shape);
        if (style.stroke !== 'none') stroke = Math.max(stroke, parseFloat(style.strokeWidth) || 0);
      });
      const bottom = Math.max(...corners.map(point => point.y)) + stroke * Math.hypot(matrix.c, matrix.d) / 2;
      const centre = (Math.min(...corners.map(point => point.x)) + Math.max(...corners.map(point => point.x))) / 2;
      const style = getComputedStyle(number);
      this.context ||= document.createElement('canvas').getContext('2d');
      if (!this.context) return;
      const font = `${style.fontStyle} ${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
      const text = number.textContent.trim();
      const fontKey = font + '\n' + text;
      if (document.fonts && !document.fonts.check(font, text) && !this.settledFonts?.has(fontKey)) {
        badge.removeAttribute('data-ub-count-ready');
        this.pendingFonts ||= new Set();
        if (!this.pendingFonts.has(fontKey)) {
          this.pendingFonts.add(fontKey);
          document.fonts.load(font, text).catch(() => {}).then(() => {
            this.pendingFonts.delete(fontKey);
            this.settledFonts ||= new Set();
            this.settledFonts.add(fontKey);
            if (this.isConnected) this.queueAlignment();
          });
        }
        return;
      }
      this.context.font = font;
      if ('letterSpacing' in this.context) this.context.letterSpacing = style.letterSpacing === 'normal' ? '0px' : style.letterSpacing;
      const metrics = this.context.measureText(number.textContent.trim());
      const ascent = metrics.fontBoundingBoxAscent;
      const descent = metrics.fontBoundingBoxDescent;
      const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.3;
      // Align the painted bag and digits, excluding SVG padding and font leading.
      const inkTop = Number.isFinite(ascent) && Number.isFinite(descent)
        ? (lineHeight - ascent - descent) / 2 + ascent - metrics.actualBoundingBoxAscent
        : 0;
      const textWidth = number.getBoundingClientRect().width / scaleX;
      const opticalX = (metrics.actualBoundingBoxLeft + textWidth - metrics.actualBoundingBoxRight) / 2;
      const left = (centre - bounds.left) / scaleX + opticalX;
      const top = (bottom + 2 - bounds.top) / scaleY - inkTop;
      cart.style.setProperty('--ub-cart-count-left', `${left.toFixed(3)}px`);
      cart.style.setProperty('--ub-cart-count-top', `${top.toFixed(3)}px`);
      badge.setAttribute('data-ub-count-ready', '');
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
